import { render, staticRenderFns } from "./ShiftTaskDisplay.vue?vue&type=template&id=644e7e72&scoped=true&"
import script from "./ShiftTaskDisplay.vue?vue&type=script&lang=ts&"
export * from "./ShiftTaskDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e7e72",
  null
  
)

export default component.exports